var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenDoorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 80,
    viewBox: "0 0 90 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3626 72.8471H40.7669L41.8847 61.6688C40.4223 60.6515 39.4563 58.9671 39.4563 57.052C39.4563 53.9595 41.9728 51.4441 45.0649 51.4441C48.1638 51.4441 50.6661 53.9595 50.6661 57.052C50.6661 58.9671 49.7087 60.6515 48.2429 61.6688L49.3626 72.8471ZM74.7734 10.8H71.4094C63.048 10.8 56.2728 17.5749 56.2728 25.9438V37.1498H24.2496C19.8094 37.1498 16.2002 40.5741 16.2002 44.7938V71.5541C16.2002 75.7776 19.8094 79.2 24.2496 79.2H65.8761C70.3219 79.2 73.9315 75.7776 73.9315 71.5541V44.7938C73.9315 40.5741 70.3219 37.1498 65.8761 37.1498H61.8814V25.9438C61.8942 20.6767 66.1502 16.4169 71.4094 16.4027H74.7734C80.0336 16.4169 84.2901 20.6767 84.3009 25.9438V37.1498H89.904V25.9438C89.904 17.5749 83.131 10.8 74.7734 10.8Z",
    fill: "#001236"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDoorIcon);
export default __webpack_public_path__ + "static/media/openDoorIcon.4aba024996205f9317e54e92eae744c8.svg";
export { ForwardRef as ReactComponent };